import { useTranslation } from "react-i18next";

import { Text } from "chameleon/lib/components";

import { displayMonetaryValue } from "checkout-experience/components/common/monetary-util";
import { FormTitle } from "checkout-experience/components/forms/form-title";
import { useChexContext } from "checkout-experience/providers/chex-context-wrapper";

import { Money } from "frontend-client";

const ShippingMethod = () => {
  const { t, i18n } = useTranslation(["combined"]);
  const { checkoutSession } = useChexContext();
  const { shippingMethods } = checkoutSession ?? {};

  let shippingCostStr: string | JSX.Element | undefined = "";

  if (shippingMethods && shippingMethods?.length > 0) {
    shippingCostStr =
      shippingMethods[0]?.cost === BigInt(0) ? (
        <Text styleVariant="body" colorVariant="positive">
          {t("shippingMethod.shippingIsFree")}
        </Text>
      ) : (
        <Text styleVariant="body" colorVariant="primaryText">
          {displayMonetaryValue(
            new Money({
              amount: shippingMethods[0]?.cost || BigInt(0),
            }),
            i18n.language
          )}
        </Text>
      );
    return (
      <>
        <FormTitle title={t("shippingMethod.title")} />
        <div>
          <Text styleVariant="body">
            {shippingMethods && shippingMethods.length > 0
              ? shippingMethods[0]?.name?.translation?.find(
                  (x) => x.languageCode === i18n.language
                )?.text
              : null}
          </Text>
          <Text styleVariant="body">
            {shippingMethods && shippingMethods.length > 0
              ? shippingMethods[0]?.description?.translation?.find(
                  (x) => x.languageCode === i18n.language
                )?.text
              : null}
          </Text>
          {shippingCostStr || ""}
          <Text styleVariant="body">
            {shippingMethods &&
            shippingMethods.length > 0 &&
            shippingMethods[0]?.estimatedDeliveryDate?.seconds
              ? t("shippingMethod.estimatedDelivery") +
                ": " +
                new Date(
                  Number(
                    shippingMethods[0]?.estimatedDeliveryDate?.seconds *
                      BigInt(1000)
                  )
                ).toLocaleDateString()
              : null}
          </Text>
        </div>
      </>
    );
  } else {
    return (
      <>
        <FormTitle title={t("shippingMethod.title")} />
        <Text styleVariant="body">
          {t("shippingMethod.noShippingMethodSpecified")}
        </Text>
      </>
    );
  }
};
export default ShippingMethod;
